import { useState } from "react";
import { useAppSelector } from "../../store/hooks";
import Animation from "../Animation";
import { PurchaseMethods } from "../orders/Purchase";
import FawryPurchase from "../orders/purchaseMethods/FawryPurchase";
import MobileWalletPurchase from "../orders/purchaseMethods/MobileWalletPurchase";

const TutorWallet = () => {
  const [purchaseBlock, setPurchaseBlock] = useState(null);
  const [amount, setAmount] = useState(null);
  const { userProfileData } = useAppSelector((state) => state.store);
  return (
    <Animation>
      <div className="overflow-x-auto space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow font-bold">
          المحفظة
        </h3>

        <div className="flex flex-wrap gap-2">
          <div
            className="rounded-lg font-bold border border-blue-400  bg-blue-100 text-blue-800 px-4 py-2 shadow-sm"
            role="alert"
          >
            رصيد المحفظة : {userProfileData?.wallet_credit ?? 0} جنيه
          </div>
          <div
            className="rounded-lg font-bold border border-yellow-500 bg-yellow-100 text-yellow-800 px-4 py-2 shadow-sm"
            role="alert"
          >
            رصيد الأكواد المجانية : {userProfileData?.free_codes_credit ?? 0}
          </div>
        </div>
        {/* form */}
        <div className="bg-white p-3 rounded-lg border shadow-sm">
          <h4 className="p-2 mb-4 border-b-2 border-primary w-fit font-bold">
            شحن المحفظة
          </h4>

          <div className="mb-3">
            <label
              htmlFor="wallet-recharge-amount"
              className="block font-bold mb-1"
            >
              قيمة الشحن ( بحد أدنى 50 جنيه )
            </label>
            <input
              onChange={(e) => {
                e.target.style = "border-color: #ddd";
                setAmount(e.target.value);
              }}
              value={amount}
              type="number"
              className="border border-gray-300 rounded-md p-2 w-3/4 mb-2 focus:outline-none focus:ring-2 focus:ring-primary"
              id="wallet-recharge-amount"
            />
          </div>

          <p className="block font-bold mb-3">إختر وسيلة الدفع</p>

          <div
            className={`flex items-center gap-2 m-2 cursor-pointer p-2 rounded-lg hover:bg-slate-100 ${
              purchaseBlock === PurchaseMethods.FAWRY && "bg-slate-100"
            }`}
            onClick={() => setPurchaseBlock(PurchaseMethods.FAWRY)}
          >
            <input
              className="accent-primary"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault1"
              style={{ marginLeft: "5px" }}
              checked={purchaseBlock === PurchaseMethods.FAWRY}
              readOnly
            />
            <p className="my-auto">فوري</p>
            <img
              className="w-10"
              src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/fawry.svg"
              alt="فوري"
            />
          </div>

          <div
            className={`flex flex-wrap items-center gap-2 m-2 cursor-pointer p-2 rounded-lg hover:bg-slate-100 ${
              purchaseBlock === PurchaseMethods.MOBILE_WALLET && "bg-slate-100"
            }`}
            onClick={() => setPurchaseBlock(PurchaseMethods.MOBILE_WALLET)}
          >
            <input
              className="accent-primary"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault2"
              style={{ marginLeft: "5px" }}
              checked={purchaseBlock === PurchaseMethods.MOBILE_WALLET}
              readOnly
            />
            <p className="my-auto">محفظة إلكترونية</p>
            <img
              className="w-20"
              src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/vodafonechash.png"
              alt="فودافون كاش"
            />
            <img
              className="w-16"
              src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/etisalat.png"
              alt="اتصالات"
            />
            <img
              className="w-9"
              src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/orange-cash.png"
              alt="اورانج كاش"
            />
            <img
              className="w-9"
              src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/ahlybank.png"
              alt="الأهلي بنك"
            />
            <img
              className="w-12"
              src="https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/cibwallet.png"
              alt="محفظة CIB"
            />
          </div>

          <div
            onClick={(e) => {
              const el = document.getElementById("amount-of-codes");
              if (!amount) {
                e.preventDefault();
                if (el) {
                  el.style = "border: 1px solid red";
                  el.focus();
                  el.scrollIntoView({
                    block: "center",
                    behavior: "smooth",
                  });
                }
              } else {
                if (el) el.style = "border: 1px solid #ddd";
              }
            }}
          >
            <div
              className={`w-full my-4 ${
                amount
                  ? "pointer-events-auto"
                  : "pointer-events-none opacity-50"
              }`}
            >
              {purchaseBlock === PurchaseMethods.FAWRY && (
                <FawryPurchase lesson_id={1} amount={amount} />
              )}
              {purchaseBlock === PurchaseMethods.MOBILE_WALLET && (
                <MobileWalletPurchase lesson_id={1} amount={amount} />
              )}
            </div>
          </div>
        </div>
      </div>
    </Animation>
  );
};

export default TutorWallet;
